<div class="flex--container carbon-footprint-container">
  <div class="flex--row spacing--margin-bottom">
    <agr-extended-notification
      notificationType="info"
      [title]="'sustainability.notification-title' | translate"
      [actionText]="getActionText()"
      (action)="toggleNotification()"
    >
      <div>
        <div *ngIf="showNotification">
          <div
            class="text--small"
            [innerHTML]="'sustainability.notification-description' | translate"
          ></div>
        </div>
      </div>
    </agr-extended-notification>
  </div>

  <div class="flex--row">
    <div class="spacing--margin-right" *ngIf="(flocks$ | async)?.length > 0">
      <mat-form-field class="flex__child--auto item-selector">
        <mat-label>{{ 'flock-overview.placeholder' | translate }}</mat-label>
        <mat-select
          [hideSingleSelectionIndicator]="true"
          placeholder="{{ 'flock-overview.placeholder' | translate }}"
          data-test="flock-overview__flock-selector1"
          (selectionChange)="onFlockSelected($event.value)"
        >
          <mat-option *ngFor="let flock of flocks$ | async" [value]="flock">
            <b>{{ flock.name }}</b> - {{ 'flock-overview.selector-option-barn' | translate }}
            {{ flock.arrival?.barn?.name }} -
            {{ flock.arrival?.arrivalDate | agrDate: 'shortDate' }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <button
        class="spacing--margin-left"
        mat-flat-button
        color="primary"
        [disabled]="!selectedFlockId"
        (click)="startCalculateCarbonFootprint()"
        data-test="flock-overview__start-calculate-carbon-footprint-button"
        style="white-space: nowrap"
      >
        {{ 'sustainability.start-calculation' | translate }}
      </button>

      <button
        class="spacing--margin-left"
        mat-flat-button
        color="primary"
        [disabled]="!selectedFlockId"
        (click)="refreshCarbonFootprintResult()"
        data-test="flock-overview__refresh-carbon-footprint-result-button"
        style="white-space: nowrap"
      >
        {{ 'sustainability.refresh-carbon-footprint' | translate }}
      </button>

      <agr-table
        *ngIf="carbonFootprintErrors.length === 0"
        [config]="tableConfig"
        [emptyTitle]=""
        [emptyDescription]=""
      ></agr-table>

      <div *ngIf="carbonFootprintErrors.length > 0" class="error-messages">
        <div>
          {{ 'Some errors were detected when calculating the carbon footprint for this flock:' }}
        </div>
        <ul>
          <li *ngFor="let error of carbonFootprintErrors" class="error">
            {{ error }}
          </li>
        </ul>
      </div>

      <div class="flex--container sustell-logo-container">
        <div class="flex-row">
          <span>Powered by</span>
        </div>
        <div class="flex-row">
          <img
            *ngIf="sustellLogoSrc !== null"
            class="sustell-logo"
            src="{{ sustellLogoSrc }}"
            alt="Sustell"
          />
        </div>
      </div>
    </div>
  </div>
</div>
